{
	"answer": {
		"received": "Ricevuta il {{when}}",
		"title": "Risposta dello studente"
	},
	"card": {
		"application": "Domanda",
		"document": "Documento",
		"download": "Scarica",
		"facts": "Dato dichiarato e soglia",
		"file_failed": "Non siamo riusciti ad aprire il documento. Riprova.",
		"no_files": "La domanda non ha documenti da mostrare.",
		"page": "Pagina",
		"page_hint": "La pagina che mostri è quella citata nell'esito.",
		"protocol": "Protocollo {{protocol}} · {{name}}",
		"relevant": "pertinente"
	},
	"closed": {
		"by": "Registrato da",
		"by_at": "{{name}}, {{when}}",
		"evidence": "Prova",
		"evidence_expired": "Chiarimento scaduto senza risposta",
		"evidence_file": "{{file}}, pagina {{page}}",
		"resolution": "Esito"
	},
	"closed_by": "da {{name}}",
	"code": {
		"cfu_below_min": "CFU sotto il minimo",
		"iseeu_above": "ISEEU sopra soglia",
		"ispeu_above": "ISPEU sopra soglia",
		"offsite_not_met": "Condizione di fuori sede non rispettata"
	},
	"columns": {
		"code": "Tipo",
		"declared": "Dichiarato",
		"due": "Scadenza",
		"name": "Cognome e nome",
		"protocol": "Prot.",
		"quotas": "Quote interessate",
		"state": "Stato",
		"threshold": "Soglia del bando"
	},
	"counters": {
		"open": "Da chiudere"
	},
	"due": {
		"date": "{{date}} alle 24:00",
		"none": "Dalla chiusura del bando",
		"soon": "Mancano meno di due giorni lavorativi"
	},
	"empty": "Nessuna segnalazione: i dati dichiarati rispettano i requisiti del bando.",
	"empty_filtered": "Nessuna segnalazione con questi filtri.",
	"facts": {
		"ceiling_q30": "Quota 30%: {{q30}}",
		"ceilings": "Quota 30%: {{q30}} · Quota 70%: {{q70}}",
		"credits_min_one": "Almeno {{count}} credito",
		"credits_min_other": "Almeno {{count}} crediti",
		"credits_one": "{{count}} credito",
		"credits_other": "{{count}} crediti",
		"not_given": "Non indicato",
		"off_site_required": "Fuori sede"
	},
	"filters": {
		"code": "Tipo",
		"quota": "Quota",
		"state": "Stato"
	},
	"off_site": {
		"commuter": "Pendolare",
		"in_site": "In sede",
		"off_site": "Fuori sede"
	},
	"outcome": {
		"already_closed": "Questa segnalazione è già stata chiusa da {{name}}.",
		"cause": "Causa",
		"cause_required": "Scegli la causa.",
		"choose": "Scegli",
		"clarification": "Chiedi chiarimento",
		"clarification_asked": "Chiarimento chiesto. Termine per la risposta: {{date}} alle 24:00",
		"corrected": "Dato corretto in base al documento",
		"not_met": "Confermato, requisito non posseduto",
		"page_cited": "Pagina citata: {{page}}.",
		"page_missing": "Indica nel documento la pagina che lo prova.",
		"page_required": "Indica la pagina del documento.",
		"question": "Domanda per lo studente",
		"question_hint": "Da 10 a 2.000 caratteri. Lo studente la legge nella sua area.",
		"question_length": "Scrivi una domanda da 10 a 2.000 caratteri.",
		"saved": "Esito registrato",
		"still_fails": "Il valore del documento non cambia l'esito di nessuna quota: registra «Confermato, requisito non posseduto».",
		"submit_clarification": "Invia richiesta",
		"submit_corrected": "Registra correzione",
		"submit_not_met": "Registra",
		"title": "Esito",
		"unchanged": "Il valore è uguale a quello dichiarato.",
		"value": "Valore del documento",
		"value_required": "Indica il valore del documento.",
		"waiting": "In attesa della risposta dello studente: l'esito si registra dopo la risposta o alla scadenza."
	},
	"page_title": "Segnalazioni",
	"pec_reply": {
		"copied": "Testo copiato.",
		"copy": "Copia testo",
		"hint": "La domanda è arrivata da una PEC: Unicasa non manda email a una casella PEC. Invia questo testo allo studente dalla PEC della struttura.",
		"title": "Testo da inviare dalla PEC della struttura"
	},
	"reviewing": "In esame da {{name}}",
	"someone": "un altro gestore",
	"state": {
		"awaiting_clarification": "Chiarimento chiesto",
		"clarification_expired": "Termine scaduto senza risposta",
		"clarification_received": "Risposta ricevuta",
		"open": "Da verificare",
		"resolved_confirmed": "Requisito non posseduto",
		"resolved_corrected": "Dato corretto"
	}
}
